/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'star': {
    width: 24,
    height: 22,
    viewBox: '0 0 24 22',
    data: '<path pid="0" d="M11.977 1a.476.476 0 00-.431.314L9.15 8.159H1.476a.474.474 0 00-.452.314.444.444 0 00.17.508l6.233 4.34-2.396 7.084a.44.44 0 00.174.508.495.495 0 00.562 0L12 16.571l6.233 4.34a.495.495 0 00.562.001.442.442 0 00.174-.509l-2.396-7.084 6.233-4.34a.443.443 0 00.17-.507.474.474 0 00-.452-.313H14.85l-2.396-6.845A.479.479 0 0011.977 1zM12 2.896l2.052 5.861a.475.475 0 00.454.313h6.554l-5.333 3.714a.444.444 0 00-.172.508l2.052 6.062-5.325-3.706a.496.496 0 00-.564 0l-5.324 3.706 2.052-6.062a.443.443 0 00-.174-.507L2.94 9.07h6.555c.207.001.39-.127.454-.313L12 2.895z" _stroke="#3D4B55"/>'
  }
})
